import { Loading } from '@/components/Loading';
import type React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkBreaks from 'remark-breaks';
import CharacterGuideImage from '../../-assets/character-saki-guide.png';
import { CharacterMessage } from '../CharacterMessage';
import styles from './index.module.scss';

export type OverallEvaluationProps = {
  comment: string | null | undefined;
  isEvaluated: boolean;
};

export const OverallEvaluation: React.FC<OverallEvaluationProps> = ({
  comment,
  isEvaluated,
}) => {
  return (
    <div className={styles.container}>
      <h2 className={styles.title}>全体フィードバック</h2>

      {isEvaluated ? (
        <CharacterMessage variant="top" characterImageUrl={CharacterGuideImage}>
          <div className={styles.markdown}>
            <ReactMarkdown remarkPlugins={[remarkBreaks]}>
              {comment || ''}
            </ReactMarkdown>
          </div>
        </CharacterMessage>
      ) : (
        <CharacterMessage variant="top" characterImageUrl={CharacterGuideImage}>
          <div className={styles.loadingContainer}>
            <Loading />
          </div>
        </CharacterMessage>
      )}
    </div>
  );
};
